function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInfoBubble = function SvgInfoBubble(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    className: "icon icon-info-bubble",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      strokeLinecap: "round",
      fill: "rgb(229, 229, 229)"
    },
    cx: -45.335,
    cy: 269.888,
    r: 128,
    transform: "matrix(0, 1, -1, 0, 397.888012, 173.335012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 114.125 96.526 L 108.555 96.526 L 108.555 92.746 L 114.125 92.746 L 114.125 96.526 Z M 114.125 113.046 L 108.555 113.046 L 108.555 98.266 L 114.125 98.266 L 114.125 113.046 Z",
    transform: "matrix(5.848606109619141, 0, 0, 7.9259419441223145, -523.6696166992188, -689.10205078125)",
    style: {
      fill: "rgb(0, 20, 140)",
      paintOrder: "fill",
      whiteSpace: "pre"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoBubble, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info-bubble.87f5d709.svg";
export { ForwardRef as ReactComponent };